import React from 'react';
import IndexTrailer from '../index';

export default function () {
  return <IndexTrailer isEvergreen={true} variant="ad" />;
}
